type UnitArtifactContentProps = {
  artifact: {
    content?: string | null;
  };
};

function UnitArtifactContent({ artifact }: UnitArtifactContentProps) {
  return (
    <div className="bg-yes border-yes radius-yes p-3 mb-3 int-col-4">
      <pre style={{ textWrap: 'auto' }}>{artifact.content ?? ''}</pre>
    </div>
  );
}

export default UnitArtifactContent;
